module.exports = __webpack_public_path__ + "static/img/banner.d931ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/banner.png
// module id = 3ThK
// module chunks = 2